/*
  Custom position button in Loox Snippets Widget
*/
document.addEventListener("DOMContentLoaded", () => {
  const wait = setInterval(() => {
    const host = document.querySelector("loox-snippets-widget");

    if (!host || !host.shadowRoot) {
      return;
    }

    clearInterval(wait);

    const shadow = host.shadowRoot;
    const btnLeft = shadow.querySelector(".arrow.left");
    const btnRight = shadow.querySelector(".arrow.right");

    if (btnLeft && btnRight) {
      host.classList.add("has-arrow");
      const offset = "-26px";
      btnLeft.style.left = offset;
      btnRight.style.right = offset;
    } else {
      host.classList.remove("has-arrow");
    }
  }, 500);
});
